import React from 'react';
import { cn } from 'lib/utils';
import CURRENCY from 'utils/currency';

interface IProps {
  amount?: number;
  unit?: string;
  statusBadge?: JSX.Element;
  className?: string;
  props?: Record<string, string>;
}

const AmountDetails = ({
  amount,
  unit,
  statusBadge,
  className = '',
  props,
}: IProps): JSX.Element => {
  return (
    <div className={cn('mb-2 flex items-center', className)} {...props}>
      {(amount || amount === 0) && (
        <>
          <span
            className="mr-2 text-3xl font-bold text-gray-blue-80"
            id="amount-converted"
          >
            {CURRENCY.convertToMainUnit(amount)}
          </span>
          <span className="mr-2 text-3xl font-medium uppercase text-gray-blue-60">
            {unit}
          </span>
        </>
      )}
      {statusBadge}
    </div>
  );
};

export default AmountDetails;
